import { render, staticRenderFns } from "./ConfirmCancel.vue?vue&type=template&id=f58c6e9a&scoped=true&"
import script from "./confirmCancel.js?vue&type=script&lang=js&"
export * from "./confirmCancel.js?vue&type=script&lang=js&"
import style0 from "../dialog.scss?vue&type=style&index=0&id=f58c6e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58c6e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
